var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "archives-list-filters" }, [
    _c(
      "div",
      { staticClass: "filters" },
      [
        !!_vm.clone.period
          ? _c("MiniFilterPreview", {
              key: _vm.clone.period,
              attrs: {
                type: "period",
                startDate: _vm.clone.startDate,
                endDate: _vm.clone.endDate,
                "on-removed": function () {
                  _vm.clone.period = null
                  _vm.clone.startDate = null
                  _vm.clone.endDate = null
                },
                label: _vm.getFilterLabel("period"),
                "default-open": _vm.lastAddedFilter === "period",
                "on-finished": function () {
                  return (_vm.lastAddedFilter = null)
                },
                autoRemoveWhenCancel: _vm.lastAddedFilter === "period",
              },
              on: {
                dateRange: function ($event) {
                  return _vm.setDateRange($event)
                },
              },
              model: {
                value: _vm.clone.period,
                callback: function ($$v) {
                  _vm.$set(_vm.clone, "period", $$v)
                },
                expression: "clone.period",
              },
            })
          : _vm._e(),
        _vm._v(" "),
        !!_vm.clone.integration
          ? _c("MiniFilterPreview", {
              key: _vm.clone.integration,
              attrs: {
                type: "integration",
                "on-removed": function () {
                  return (_vm.clone.integration = null)
                },
                label: _vm.getFilterLabel("integration"),
                "default-open": _vm.lastAddedFilter === "integration",
                "on-finished": function () {
                  return (_vm.lastAddedFilter = null)
                },
                autoRemoveWhenCancel: _vm.lastAddedFilter === "integration",
              },
              model: {
                value: _vm.clone.integration,
                callback: function ($$v) {
                  _vm.$set(_vm.clone, "integration", $$v)
                },
                expression: "clone.integration",
              },
            })
          : _vm._e(),
        _vm._v(" "),
        !!_vm.clone.visitorId
          ? _c("MiniFilterPreview", {
              key: _vm.clone.visitorId,
              attrs: {
                type: "visitorId",
                "on-removed": function () {
                  return (_vm.clone.visitorId = null)
                },
                label: _vm.getFilterLabel("visitorId"),
                "default-open": _vm.lastAddedFilter === "visitorId",
                "on-finished": function () {
                  return (_vm.lastAddedFilter = null)
                },
                autoRemoveWhenCancel: _vm.lastAddedFilter === "visitorId",
              },
              model: {
                value: _vm.clone.visitorId,
                callback: function ($$v) {
                  _vm.$set(_vm.clone, "visitorId", $$v)
                },
                expression: "clone.visitorId",
              },
            })
          : _vm._e(),
        _vm._v(" "),
        Object.keys(_vm.clone).includes("conversationId") &&
        !!_vm.clone.conversationId
          ? _c("MiniFilterPreview", {
              key: _vm.clone.conversationId,
              attrs: {
                type: "conversationId",
                "on-removed": function () {
                  return (_vm.clone.conversationId = null)
                },
                label: _vm.getFilterLabel("conversationId"),
                "default-open": _vm.lastAddedFilter === "conversationId",
                "on-finished": function () {
                  return (_vm.lastAddedFilter = null)
                },
                autoRemoveWhenCancel: _vm.lastAddedFilter === "conversationId",
              },
              model: {
                value: _vm.clone.conversationId,
                callback: function ($$v) {
                  _vm.$set(_vm.clone, "conversationId", $$v)
                },
                expression: "clone.conversationId",
              },
            })
          : _vm._e(),
        _vm._v(" "),
        Object.keys(_vm.clone).includes("storyId") && !!_vm.clone.storyId
          ? _c("MiniFilterPreview", {
              key: _vm.clone.storyId,
              attrs: {
                type: "storyId",
                "on-removed": function () {
                  return (_vm.clone.storyId = null)
                },
                label: _vm.getFilterLabel("storyId"),
                "default-open": _vm.lastAddedFilter === "storyId",
                "on-finished": function () {
                  return (_vm.lastAddedFilter = null)
                },
                autoRemoveWhenCancel: _vm.lastAddedFilter === "storyId",
              },
              model: {
                value: _vm.clone.storyId,
                callback: function ($$v) {
                  _vm.$set(_vm.clone, "storyId", $$v)
                },
                expression: "clone.storyId",
              },
            })
          : _vm._e(),
        _vm._v(" "),
        Object.keys(_vm.clone).includes("userIds") && !!_vm.clone.userIds
          ? _c("MiniFilterPreview", {
              directives: [
                {
                  name: "tippy",
                  rawName: "v-tippy",
                  value: { content: _vm.getFilterLabel("userIds") },
                  expression: "{ content: getFilterLabel('userIds') }",
                },
              ],
              key: _vm.clone.userIds,
              attrs: {
                type: "userIds",
                "on-removed": function () {
                  return (_vm.clone.userIds = null)
                },
                label: _vm.getFilterLabel("userIds"),
                "default-open": _vm.lastAddedFilter === "userIds",
                "on-finished": function () {
                  return (_vm.lastAddedFilter = null)
                },
                users: _vm.users,
                autoRemoveWhenCancel: _vm.lastAddedFilter === "userIds",
              },
              model: {
                value: _vm.clone.userIds,
                callback: function ($$v) {
                  _vm.$set(_vm.clone, "userIds", $$v)
                },
                expression: "clone.userIds",
              },
            })
          : _vm._e(),
        _vm._v(" "),
        _c(
          "a-popover",
          {
            attrs: {
              visible: _vm.filterMenuVisible,
              overlayClassName: "filterMenu no-padding",
              placement: "bottom",
              trigger: "click",
            },
            on: {
              visibleChange: function (isVisible) {
                return (_vm.filterMenuVisible = isVisible)
              },
            },
          },
          [
            _c("div", { attrs: { slot: "content" }, slot: "content" }, [
              _c("div", { staticClass: "custom-list-wrapper filter-list-bg" }, [
                _c("div", { staticClass: "custom-list" }, [
                  Object.keys(_vm.clone).includes("period")
                    ? _c(
                        "div",
                        {
                          staticClass: "custom-list-item",
                          on: {
                            click: function ($event) {
                              return _vm.addFilter("period")
                            },
                          },
                        },
                        [
                          _c("span", { staticClass: "material-icons" }, [
                            _vm._v(" date_range "),
                          ]),
                          _vm._v(
                            "\n                            " +
                              _vm._s(_vm.$t("chatbotv2.date")) +
                              "\n                        "
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  Object.keys(_vm.clone).includes("userIds")
                    ? _c(
                        "div",
                        {
                          staticClass: "custom-list-item",
                          on: {
                            click: function ($event) {
                              return _vm.addFilter("userIds")
                            },
                          },
                        },
                        [
                          _c("span", { staticClass: "material-icons" }, [
                            _vm._v(" badge"),
                          ]),
                          _vm._v(
                            "\n                            Kullanıcı Filtre\n                        "
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  Object.keys(_vm.clone).includes("visitorId") &&
                  !_vm.isGraphShowing
                    ? _c(
                        "div",
                        {
                          staticClass: "custom-list-item",
                          on: {
                            click: function ($event) {
                              return _vm.addFilter("visitorId")
                            },
                          },
                        },
                        [
                          _c("span", { staticClass: "material-icons" }, [
                            _vm._v("fingerprint"),
                          ]),
                          _vm._v(
                            "\n                            " +
                              _vm._s(_vm.$t("chatbotv2.userId")) +
                              "\n                        "
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  Object.keys(_vm.clone).includes("conversationId") &&
                  !_vm.isGraphShowing
                    ? _c(
                        "div",
                        {
                          staticClass: "custom-list-item",
                          on: {
                            click: function ($event) {
                              return _vm.addFilter("conversationId")
                            },
                          },
                        },
                        [
                          _c("span", { staticClass: "material-icons" }, [
                            _vm._v("fingerprint"),
                          ]),
                          _vm._v(
                            "\n                            " +
                              _vm._s(_vm.$t("chatbotv2.conversationId")) +
                              "\n                        "
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  Object.keys(_vm.clone).includes("integration")
                    ? _c(
                        "div",
                        {
                          staticClass: "custom-list-item",
                          on: {
                            click: function ($event) {
                              return _vm.addFilter("integration")
                            },
                          },
                        },
                        [
                          _c("span", { staticClass: "material-icons" }, [
                            _vm._v("public"),
                          ]),
                          _vm._v(
                            "\n                            " +
                              _vm._s(_vm.$t("chatbotv2.integration")) +
                              "\n                        "
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  Object.keys(_vm.clone).includes("storyId")
                    ? _c(
                        "div",
                        {
                          staticClass: "custom-list-item",
                          on: {
                            click: function ($event) {
                              return _vm.addFilter("storyId")
                            },
                          },
                        },
                        [
                          _c("span", { staticClass: "material-icons" }, [
                            _vm._v("schema"),
                          ]),
                          _vm._v(
                            "\n                            " +
                              _vm._s(_vm.$t("chatbotv2.story")) +
                              "\n                        "
                          ),
                        ]
                      )
                    : _vm._e(),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "add-button" }, [
              _c("span", { staticClass: "material-icons" }, [_vm._v(" add ")]),
              _vm._v(" "),
              _c("div", { staticClass: "add-button-text" }, [
                _vm._v(_vm._s(_vm.$t("chatbotv2.addFilter"))),
              ]),
            ]),
          ]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }